// Module
var code = "<script>let $ctrl</script> <rzslider rz-slider-model=\"$ctrl.model\" rz-slider-options=\"$ctrl.sliderOptions\"></rzslider> ";
// Exports
module.exports = code;